import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedPolling } from '@eggplant/data-request'
import type { GetTestConfigTaskSummaryResponse } from '@eggplant/types'

interface Props {
  id: string
  isPoll: boolean
  interval?: number
  onSuccess?: (data: GetTestConfigTaskSummaryResponse) => void
}

const PollAiTestConfigTaskSummaryRequest = ({
  id,
  isPoll,
  interval = 5000,
  onSuccess
}: Props) => {
  const url = `${AI_API_SERVICE}/testconfigtasks/${id}/summary`

  return (
    <AuthenticatedPolling<GetTestConfigTaskSummaryResponse>
      intervalMs={interval}
      isPolling={isPoll}
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default PollAiTestConfigTaskSummaryRequest
